import React from 'react';
import { Box, Tabs, Tab, Paper, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import RolesPermissionsTab from '../components/settings/RolesPermissionsTab';
import UsersTab from '../components/settings/UsersTab';
import NotificationsTab from '../components/settings/NotificationsTab';
import EmailNotificationsTab from '../components/settings/EmailNotificationsTab';
import AiInstructionsTab from '../components/settings/AiInstructionsTab';
import LogsTab from '../components/settings/LogsTab';
import HardwareTab from '../components/settings/HardwareTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`settings-tabpanel-${index}`} aria-labelledby={`settings-tab-${index}`} {...other}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const SettingsPage: React.FC = () => {
  const { user } = useAuth();
  const [tab, setTab] = React.useState(0);

  const hasAdmin = user?.role === 'admin';

  if (!hasAdmin) {
    return (
      <Paper sx={{ mt: 4, p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#004273' }}>Ustawienia</Typography>
        <Alert severity="warning">Brak uprawnień. Tylko administrator może zarządzać rolami i uprawnieniami.</Alert>
      </Paper>
    );
  }

  return (
    <Paper sx={{ mt: 4, p: 0, overflow: 'hidden', border: '1px solid #e0e0e0' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 3, py: 2 }}>
        <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', color: '#004273' }}>
          Ustawienia
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="settings tabs" sx={{ px: 2 }}>
          <Tab label="Role i uprawnienia" />
          <Tab label="Użytkownicy" />
          <Tab label="Powiadomienia" />
          <Tab label="Powiadomienia e-mail" />
          <Tab label="Instrukcje AI" />
          <Tab label="Logi" />
          <Tab label="Hardware" />
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <RolesPermissionsTab />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <UsersTab />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <NotificationsTab />
      </TabPanel>
      <TabPanel value={tab} index={3}>
        <EmailNotificationsTab />
      </TabPanel>
      <TabPanel value={tab} index={4}>
        <AiInstructionsTab />
      </TabPanel>
      <TabPanel value={tab} index={5}>
        <LogsTab />
      </TabPanel>
      <TabPanel value={tab} index={6}>
        <HardwareTab />
      </TabPanel>
    </Paper>
  );
};

export default SettingsPage;


